import CountryConfigContext from '.';
import { ProviderProps } from './types';

const CountryConfigProvider = ({
  children,
  config = {}
}: ProviderProps): JSX.Element => {
  return (
    <CountryConfigContext.Provider value={config}>
      {children}
    </CountryConfigContext.Provider>
  );
};

export default CountryConfigProvider;
